// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2024 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import TypographyStyle from "@insite/mobius/Typography/TypographyStyle";
import { color, ellipsis, xScreen } from "@turnerBlueprint/XDL/Utilities";
import { featuredCategoriesStyles } from "@turnerScienceBlueprint/App/Widgets/FeaturedCategories/FeaturedCategories";
import { css } from "styled-components";

featuredCategoriesStyles.wrapper = {
    css: css`
        display: flex;
        flex-wrap: wrap;
        gap: 26px;
        padding-bottom: 40px;
        width: 100%;
        ${xScreen("lte", "md")} {
            row-gap: 20px;
            column-gap: 52px;
        }
    `,
};

featuredCategoriesStyles.carouselWrapper = {
    css: css`
        padding-bottom: 40px;
    `,
};

featuredCategoriesStyles.cardContainer = {
    css: css`
        width: 144px;
        ${xScreen("gte", "xl")} {
            width: 172px;
        }
    `,
};

featuredCategoriesStyles.cardContainerLink = {
    css: css`
        width: 100%;
        display: flex;
        &:hover {
            ${TypographyStyle} {
                color: ${color("common.ui9")};
            }
        }
    `,
    typographyProps: {
        css: css`
            display: flex;
            flex-direction: column;
            row-gap: 12px;
            width: 100%;
        `,
    },
};

featuredCategoriesStyles.subtitle = {
    variant: "h6",
    color: "text",
    css: css`
        text-align: center;
        ${ellipsis(3)}
        margin-bottom: 0;
        width: 100%;
    `,
};
